import React from "react";

//Styles
import "./Button.scss";

function Button({ styleType, children }) {
  return <button className={`button ${styleType}`}>{children}</button>;
}

export default Button;
